import axios from "axios"
import { apiUrl } from "../enumerations/constants"

export const getCustomerActivities = async (token, query) => {
  const { data: response } = await axios.get(`${apiUrl}/customer-activities?${query}`, {
    headers: {
      "Token": token
    }
  })
  return response
}
